// Serviciospages puede modularizarse en src/features/servicios/Serviciospages.jsx
import Hero from "../features/hero/Hero";
import Galeria from "../features/galeria/Galeria";
import Serviciospages from "../pages/Serviciospages";
import Consejos from "../features/consejos/Consejos";
export default function Home() {
  return (
    <>
      <Hero className="hero" />
      <Galeria className="galeria" />
      <Serviciospages className="servicio-content" />
      <Consejos className="consejos" />
    </>
  );
}
